// @ts-nocheck
import React from 'react';
import { IMaskInput } from 'react-imask';

import { phoneMaskHandler } from 'src/utils/phone-mask-handler/phone-mask-handler';

import { Masks } from './masks';

interface PhoneMaskProps {
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
  countryCode: string;
}

export const PhoneMask = React.forwardRef<HTMLElement, PhoneMaskProps>(
  function TextMaskCustom(props, ref) {
    const { onChange, countryCode, ...other } = props;
    return (
      <IMaskInput
        {...other}
        mask={Masks}
        dispatch={(value, dynamicMasked, _) => {
          const number = (dynamicMasked.value + value).replace(/\D/g, '');

          return dynamicMasked.compiledMasks.find(function (m) {
            return number.indexOf(m.startsWith) === 0;
          });
        }}
        inputRef={ref}
        onAccept={(value: any) => {
          onChange({ target: { name: props.name, value } });
        }}
      />
    );
  }
);
